import { Outlet } from "react-router-dom";
import Header from "./header";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "./footer";
import { UpdateBanner } from "./update-banner";

export function Layout() {
    return (
        <div id="page">
            <UpdateBanner />
            <Header />
            <div className="main-content">
                <Container>
                    <Row>
                        <Col>
                            <Outlet />
                        </Col>
                    </Row>
                </Container>
            </div>
            <Footer />
        </div>
    );
}